import { bindRouter } from '../interface/route';
import { injectConfigRoute } from '../interface/config';
import { injectQueryURL } from '../interface/util';
import Router from './router';
import { IContainer } from '../interface/container';

export function bind(container: IContainer): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const settings = injectConfigRoute(container);
            const query = await injectQueryURL(container);
            const router = Router(settings, query);

            bindRouter(router, container);

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}
